import { useSettingsQuery } from 'src/api/queries/userQueries';
import {
  AdminSettingsSection,
  PageBody,
  SaveChangesBar,
  SettingsNavigation,
  WebhookUrlList,
} from 'src/components';
import styles from './styles.module.scss';
import { useAtom } from 'jotai';
import { useMemo } from 'react';
import ReactSwitch from 'react-switch';
import { webhookSettingsAtom } from 'src/shared/settings/webhook';
import { ACTION_TYPES } from 'src/shared/settings/base';

export const WebhookSettings = () => {
  const { isLoading } = useSettingsQuery();

  const [webhookSettings, updateWebhookSettings] = useAtom(webhookSettingsAtom);

  const events = useMemo(() => {
    if (!webhookSettings) return [];

    return Object.entries(webhookSettings.callback_events).map(([key, value]: [string, any]) => ({
      key,
      enabled: value,
    }));
  }, [webhookSettings]);

  const handleEventChange = (name: string, value: boolean) =>
    updateWebhookSettings({ type: ACTION_TYPES.UPDATE_STATE, payload: { callback_events: { [name]: value } } });

  if (isLoading) return null;

  return (
    <div className={styles.pageWrapper}>
      <SettingsNavigation />
      <SaveChangesBar />

      <PageBody narrow>
        <AdminSettingsSection title="Webhooks">
          <WebhookUrlList
            value={webhookSettings.web_urls}
            onChange={(value: string) =>
              updateWebhookSettings({ type: ACTION_TYPES.UPDATE_STATE, payload: { web_urls: value } })
            }
          />
        </AdminSettingsSection>
        <AdminSettingsSection title="Asset events">
          <div className={styles.eventList}>
            {events.map(({ key, enabled }) => (
              <div key={key} className={styles.eventRow}>
                <ReactSwitch
                  checked={enabled}
                  onChange={(value) => handleEventChange(key, value)}
                  checkedIcon={false}
                  uncheckedIcon={false}
                  onColor="#2e53e3"
                />
                <label>{key}</label>
              </div>
            ))}
          </div>
        </AdminSettingsSection>
      </PageBody>
    </div>
  );
};
